<template>
  <p>
    <span>
      <b>
        {{atributNaziv}}:
      </b>
    </span>
    {{ narocilo[atribut] }}
  </p>
</template>
<script>
export default {
  name: 'MojaNarocilaParagraf',
  props: {
    narocilo: Object,
    atributNaziv: '',
    atribut: ''
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Mojprofil/T2klub/MojaNarocilaInfo/MojaNarocilaParagraf.vue